import * as yup from 'yup';

export const getUserSignUpValidationSchema = (t: (key: string) => string) => {
  return yup.object({
    userId: yup.string(),
    address: yup.string(),
    firstName: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    lastName: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    phone: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    password: yup
      .string()
      .required(t('general.errors.mandatoryField'))
      .min(8, t('general.errors.passwordTooShort')),

    confirmPassword: yup
      .string()
      .required(t('general.errors.mandatoryField'))
      .min(8, t('general.errors.passwordTooShort'))
      .oneOf([yup.ref('password')], t('login.errors.passwordsMustMatch')),
  });
};

const initialValues = {
  address: '',
  firstName: '',
  lastName: '',
  phone: '',
  password: '',
  confirmPassword: '',
};

export const getUserSignUpInitialValues = () => {
  return initialValues;
};
